import {
  AgentAppointments,
  AgentPortfolio,
  allRegisteredAgents,
  ContactQueries,
  LeadDetails,
  MarketedPropertyListing,
  MessagesList,
  MLSPropertiesData,
  OffMarketProperty,
  Pagination,
  PayrollSubmissions,
  PropertyForm,
  SendMessageRequest,
  Tickets,
  UserBlogs,
  UserDetails,
  UserProperties,
  UserScheduledTour,
  youtube,
  RentalListing,
  PropertySearch,
} from 'src/app/shared/models';

export interface UserState {
  data: [];
  details: UserDetails | null;
  isLoading: boolean;
  error: any;
  isDeactivating: boolean;
  properties: MarketedPropertyListing[];
  wishList: [];
  addedPropertyInwishList: [];
  userPropertyDetails: MarketedPropertyListing | null;
  tickets: Tickets[];
  ticketDetails: Tickets | null;
  agentLeads: LeadDetails[];
  marketedAgentLeads: LeadDetails[];
  agentAppointments: AgentAppointments[];
  scheduledTours: UserScheduledTour[];
  mlsProperties: MLSPropertiesData;
  messages: SendMessageRequest[];
  messagesList: MessagesList[];
  messagedUserDetails: UserDetails | null;
  blogs: UserBlogs[];
  blogDetails: UserBlogs | null;
  allAgents: allRegisteredAgents[];
  pagination: Pagination | null;
  agentDetails: allRegisteredAgents | null;
  youtubeVideos: youtube[];
  tweets: any;
  instagramPosts: any;
  contactQueries: ContactQueries[];
  agentPortfolio: AgentPortfolio | null;
  payrollSubmissions: PayrollSubmissions[] | null;
  payrollSubmissionDetails: PayrollSubmissions | null;
  offMarketProperties: {
    list: OffMarketProperty[] | null;
    details: OffMarketProperty | null;
  };
  rentalListings: RentalListing[] | null;
  rentalListingById: RentalListing | null;
  rentalSearchResults: RentalListing[] | null;
  rentalMapMarkers: any[] | null;
  arisMarketedProperties: {
    list: MarketedPropertyListing[] | null;
    details: MarketedPropertyListing | null;
    query: PropertySearch | null;
    mapProperties: MarketedPropertyListing[] | null;
  };
  isKycPolling: boolean;
  isKycPollingTimedOut: boolean;
  pendingRentalSubmitAfterKycId: number | null;
}

export const initialState: UserState = {
  data: [],
  details: null,
  isLoading: false,
  error: null,
  isDeactivating: false,
  properties: [],
  wishList: [],
  addedPropertyInwishList: [],
  userPropertyDetails: null,
  tickets: [],
  ticketDetails: null,
  agentLeads: [],
  marketedAgentLeads: [],
  agentAppointments: [],
  scheduledTours: [],
  mlsProperties: {
    list: null,
    details: null,
    query: null,
    mlsMapProperties: [],
  },
  messages: [],
  messagesList: [],
  messagedUserDetails: null,
  blogs: [],
  blogDetails: null,
  pagination: null,
  allAgents: [],
  agentDetails: null,
  youtubeVideos: [],
  tweets: null,
  instagramPosts: null,
  contactQueries: [],
  agentPortfolio: null,
  payrollSubmissions: null,
  payrollSubmissionDetails: null,
  offMarketProperties: {
    list: null,
    details: null,
  },
  rentalListings: null,
  rentalListingById: null,
  rentalSearchResults: null,
  rentalMapMarkers: null,
  arisMarketedProperties: {
    list: null,
    details: null,
    query: null,
    mapProperties: null,
  },
  isKycPolling: false,
  isKycPollingTimedOut: false,
  pendingRentalSubmitAfterKycId: null,
};
